module.exports = __webpack_public_path__ + "static/media/apercu-bold_italic.677d2bc0.woff";